export default __webpack_public_path__ + "static/media/vanilla-js-clock.63aaacd1.png";